import script from "./ItemTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./ItemTemplate.vue?vue&type=script&setup=true&lang=js"

import "./ItemTemplate.vue?vue&type=style&index=0&id=8a503468&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a503468"]])

export default __exports__